import React from "react";
import { StyleSheet } from "react-native";
import { HelperText } from "react-native-paper";
import { OutlinedInput } from "./OutlinedInput";
import { useTranslation } from "react-i18next";

import { Field } from "../../config/companies/config";

interface TextAreaFieldProps {
  field: Field;
  value: string;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
}

export const TextAreaField = ({
  field,
  value,
  onChange,
  errors = {},
}: TextAreaFieldProps) => {
  const { t } = useTranslation();
  // const [inputHeight, setInputHeight] = useState(40);

  const handleChange = (newValue: string) => {
    if (field.autoCapitalize === "characters") {
      onChange(field.name, newValue.toUpperCase());
    } else {
      onChange(field.name, newValue);
    }
  };

  // const handleContentSizeChange = (event: NativeSyntheticEvent<TextInputContentSizeChangeEventData>) => {
  //   setInputHeight(event.nativeEvent.contentSize.height);
  // };

  const label = t(field.label) + (field.required ? "*" : "");

  return (
    <>
      <OutlinedInput
        testID={"description"}
        label={label}
        outlineStyle={[
          styles.textareaOutline,
          // { height: Math.max(40, inputHeight) },
        ]}
        value={value}
        onChangeText={handleChange}
        multiline
        numberOfLines={4}
        // onContentSizeChange={handleContentSizeChange}
        contentStyle={styles.textareaContent}
        autoFocus={field.autoFocus}
        autoCapitalize={field.autoCapitalize}
        error={!!errors[field.name]}
      />
      {errors[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  textareaOutline: {},
  textareaContent: {
    // marginVertical: 10,
  },
});
